<template>
  <div
    ref="root"
    v-show="visible"
    class="popup alert"
  >
    <div
      class="content"
    >
      <div class="main">
        <!-- isErrorの場合は.warn-titleクラスを
        !isError&&isWarningの場合は.warn-titleクラスを付与 -->
        <div class="message" v-bind:class="{ contact: contact,'warn-title': !isError && isWarning,'error-title':isError }">
          <span v-if="isError"><i v-html='svg.error'></i>{{ $t('警告') }}</span>
          <span v-if="!isError&&isWarning"><i v-html='svg.warning'></i>{{ $t('{count}件の注意点', { count: warningCount }) }}</span>
          <p v-bind:class="{ contact: contact}" v-html="message"></p>
        </div>
        <p class="message" v-if="unknownErrorExist">
          {{ $t('不明なエラーが発生する時は') }}
          <a :href="detailLinks[String(999)]" target="_blank">{{ $t('こちら') }}</a>
          {{ $t('をご参照ください。') }}<br>{{ $t('考えられる原因をまとめています。') }}
        </p>
        <ul v-if="errors.length > 0" class="errors">
          <li v-for="(err, idx) in errors" :key="idx">
            <div v-if="error_list.includes(err.ecode) || warning_list.includes(err.ecode)" :class="{
      erroritem: error_list.includes(err.ecode),
      warnitem: warning_list.includes(err.ecode)
    }">
              <div class="headline">
                <i v-html='svg.warning' v-if="warning_list.includes(err.ecode)"></i>
                <i v-html='svg.error' v-if="error_list.includes(err.ecode)"></i>
                <p v-html="makeMessage(idx, err)" style="line-height: 1.5;"></p>
                <div class='sample-image' v-show="makeSampleImage(err)">
                  <img :src="makeSampleImage(err)" alt="sample image">
                </div>
              </div>
              <img v-show="err.image !== null && err.image.length > 0" :src="err.image" class="error-img"/>
            </div>
            <div v-else>
              <p>{{ $t('不明なエラーが発生しました。') }}</p>
              <p>{{ $t('詳細は') }}<a :href="detailLinks[String(999)]" target="_blank">{{ $t('こちら') }}</a>{{ $t('をご参照ください。') }}</p>
            </div>
          </li>
        </ul>
        <a class="button" href="/contact" target="_blank">{{ $t('オンラインで相談する') }}</a>
        <a class="button" @click="onClose">OK</a>
      </div>
    </div>
  </div>
</template>

<script>

import border from '@/assets/images/ui/dot-border.png';
import bg from '@/assets/images/ui/drag-and-drop.png';
import svgError from '@/assets/images/ui/error.svg';
import svgWarning from '@/assets/images/ui/warning.svg';
import cam_errors from '@/assets/jsons/cam_errors.json';
import cam_warnings from '@/assets/jsons/cam_warnings.json';
import PopupBase from './PopupBase.vue';

export default {
  name: 'AlertPopup',
  extends: PopupBase,
  components: {
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      unknownErrorExist: false,
      outside: false,
      message: 'Some parts are not included in the cutting code because they contain parts that cannot be cut. Please check the size of the furniture again.',
      contact: false,
      isError: false,
      isWarning: false,
      warningCount: 0,
      errors: [], // { "ecode": number, "message": string, "image": string, "img_name": string }[]
      error_list: [],
      warning_list: [],
      bg: bg,
      border: border,
      detailLinks: {
        '10': 'https://docs.emarf.co/EMARFCAM-1515709244d280178fbfd01da0d991a7#193c4314cc1c4fb3bd98d0501eaafcb2',
        '11': 'https://docs.emarf.co/EMARFCAM-1515709244d280178fbfd01da0d991a7#1525709244d280e3912df8cf36b00326',
        '12': 'https://docs.emarf.co/EMARFCAM-1515709244d280178fbfd01da0d991a7#36e210a238ab4994b560c75e0885aec4',
        '13': 'https://docs.emarf.co/EMARFCAM-1515709244d280178fbfd01da0d991a7#f40a66616a9945ef8da87982e7653032',
        '70': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w70',
        '71': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w71',
        '72': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w72',
        '73': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w73',
        '80': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w80',
        '81': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w81',
        '82': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w82',
        '83': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w83',
        '84': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w84',
        '85': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w85',
        '86': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w86',
        '87': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w87',
        '88': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w88',
        '90': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w90',
        '91': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w91',
        '92': 'https://emarf-v3.gitbook.io/emarf3-guide/01/5emarfnowebnitsuite#w92',
        '999': 'https://emarf-v3.gitbook.io/emarf3-guide/01/15ernochekkurisuto'
      },
      sampleImages: {
        '70': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FV4MiycSJa5szZ5bAq4bM%252Fecode70.png%3Falt%3Dmedia%26token%3D3144238b-d8e7-4192-9639-52d98872bde3&width=768&dpr=1&quality=100&sign=8acd4ca7&sv=1',
        '71': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252F8Xg3BTVYEt4Hm1nC23Rs%252Fecode71.png%3Falt%3Dmedia%26token%3Dd04ed747-1d76-490b-92fc-284bde88eb02&width=768&dpr=1&quality=100&sign=bd25c69e&sv=1',
        '72': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FOlMsPaC4Yah9OA6umt3n%252Fecode72.png%3Falt%3Dmedia%26token%3Df8044e8f-8ac4-4aec-8cd4-67fece57faf7&width=768&dpr=1&quality=100&sign=5f1fbd1c&sv=1',
        '73': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FX5TztnWkQkPPFUfgbazi%252Fecode73.png%3Falt%3Dmedia%26token%3Dc5ae9fb1-8a69-4cb0-88b4-a18866f7060f&width=768&dpr=1&quality=100&sign=72750cc4&sv=1',
        '80': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FNncwjm3HRB6WZli1Tedy%252Fe80.png%3Falt%3Dmedia%26token%3D6fc1d5ec-54dc-413d-ad07-5b080b56915f&width=768&dpr=1&quality=100&sign=7ca156f5&sv=1',
        '81': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FOFWJlloTeWcNiq8TsEU2%252Fe81.png%3Falt%3Dmedia%26token%3D7eace8fc-9de7-4446-bc31-30a4c323e024&width=768&dpr=1&quality=100&sign=128226c8&sv=1',
        '82': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FaqURCBvMhFgtRngolPgy%252Fe82.png%3Falt%3Dmedia%26token%3D53221ccf-b690-41d6-9913-080f2f126634&width=768&dpr=1&quality=100&sign=175dcaa3&sv=1',
        '83': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252Fjo20JqHoBR6TR2feNhaq%252Fe83.png%3Falt%3Dmedia%26token%3De20be61b-1354-4e02-938f-8b2334b0ae82&width=768&dpr=1&quality=100&sign=b7b5deaa&sv=1',
        '84': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FtOkJ1iWhjnzN6obdGEcn%252Fe84.png%3Falt%3Dmedia%26token%3D7d63647e-18c2-4c7d-90f3-f624fa889256&width=768&dpr=1&quality=100&sign=c69f0474&sv=1',
        '85': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252Fk2KHbGjcXWwJTuOVVpTL%252Fe85.png%3Falt%3Dmedia%26token%3D2265934f-3ccb-4408-ae7d-a4d3f3c50679&width=768&dpr=1&quality=100&sign=2a4dadcb&sv=1',
        '86': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FleKjkM4HHA9HEQTSdVPD%252Fe86.png%3Falt%3Dmedia%26token%3D1a0c315c-e042-4ed1-a08b-d4d370541ddb&width=768&dpr=1&quality=100&sign=ac46e20c&sv=1',
        '87': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252F8v6E1FqoHWetgmdvoNDc%252Fe87.png%3Falt%3Dmedia%26token%3De9255bcc-2082-483f-9a76-18565405e5c9&width=768&dpr=1&quality=100&sign=86be89b9&sv=1',
        '88': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FjuLCizVTZO31hRWe5c2c%252Fe88.png%3Falt%3Dmedia%26token%3D1d37a361-da84-4895-873d-ae335cc3344f&width=768&dpr=1&quality=100&sign=3a31ae69&sv=1',
        '90': 'https://files.gitbook.com/v0/b/gitbook-x-prod.appspot.com/o/spaces%2F-M6A2dlqTXmTK6qNH38N%2Fuploads%2FO5zHwQnkSxhXfzQ3SVcZ%2F%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88%202024-06-27%2016.52.09.png?alt=media&token=b3038477-34ce-49d7-b27f-13c63a163a33',
        '91': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FuXvwKWF5cpwq5TFdL0tw%252Fe91.png%3Falt%3Dmedia%26token%3Ddaf493c2-78e2-4efc-98d8-0ba109f5996f&width=768&dpr=1&quality=100&sign=d9428d95&sv=1',
        '92': 'https://emarf-v3.gitbook.io/~gitbook/image?url=https%3A%2F%2F1631103045-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252F-M6A2dlqTXmTK6qNH38N%252Fuploads%252FI2u60uRwWepMg87hpvyX%252Fe92.png%3Falt%3Dmedia%26token%3D41c614bc-d15b-4869-bc90-51cea7642239&width=768&dpr=1&quality=100&sign=d7ad6884&sv=1'
      },
      svg: {
        error: svgError,
        warning: svgWarning
      }
    };
  },
  mounted () {
    // eslint-disable-next-line camelcase
    for (let i in cam_errors) {
      this.error_list.push(Number(i));
    }
    // eslint-disable-next-line camelcase
    for (let i in cam_warnings) {
      this.warning_list.push(Number(i));
    }
  },
  methods: {
    makeMessage (index, content) {
      const { detailLinks } = this;
      let code = `メッセージ番号: ${content.ecode}`;
      if (Object.keys(detailLinks).includes(String(content.ecode))) {
        code = `<a href="${detailLinks[String(content.ecode)]}" target="_blank">${code}</a>`;
      }
      return `${content.message} (詳しくは${code}をご覧ください)`;
    },
    makeSampleImage (content) {
      const {sampleImages} = this;
      if (Object.keys(sampleImages).includes(String(content.ecode))) {
        return sampleImages[String(content.ecode)];
      } else {
        return null;
      }
    },
    detectErrorType (errors) {
      for (let i = 0; i < errors.length; i++) {
        if (this.error_list.includes(errors[i].ecode)) {
          this.isError = true;
        } else {
          this.isError = false;
        }
        if (this.warning_list.includes(errors[i].ecode)) {
          this.isWarning = true;
        } else {
          this.isWarning = false;
        }
      }
      this.warningCount = errors.filter(err => this.warning_list.includes(err.ecode)).length;
    }
  },
  // this.errorを監視し続け、変化があるたびにdetectErrorTypeを呼び出す
  watch: {
    errors: {
      handler: function (val) {
        this.detectErrorType(val);
      },
      deep: true
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/AlertPopup.vue